import { createSelector } from 'reselect'

const teamsSelector = (state) => state.teams

export const getTeamData = createSelector([teamsSelector], (state) => state)
